import config from "../../config";
import axios from "axios";

function axios_api(api) {
    axios.defaults.baseURL = api;
    axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token-rules")}`; 
   return axios
  }




    function saveRules(body) {
        console.log('data :', body)
        const result =  axios_api(config.api+'/rule').post(config.api+'/rule',body).then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
        
    }

    function GetRulesById(id) {
        const result =  axios_api(config.api+'/rule/'+id).get(config.api+'/rule/'+id).then((res)=>{
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false}
        });
        return result;
    }

    function GetRulesByForm(id) {
        const result =  axios_api(config.api+'/ruleByForm/'+id).get(config.api+'/ruleByForm/'+id).then((res)=>{        
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false};
        });
        return result;
        
    }

    function deleteRulesByForm(id) {

        const result =  axios_api(config.api+'/rule/'+id).delete(config.api+'/rule/'+id).then((res)=>{
        return {'data':res.data,'ok':true};
        
        }).catch((error)=>{
        return {'data':error,'ok':false};
        });
        return result;
        
    }


    function GetLastversionRule(id) {
        const result = axios_api(config.api+'/lastversion/'+id).get(config.api+'/lastversion/'+id).then((res)=>{    
        return {'data':res.data,'ok':true};
        }).catch((error)=>{
        return {'data':error,'ok':false};
        });
        return result;
    }


    export {
        GetLastversionRule,
        GetRulesByForm,
        deleteRulesByForm,
        saveRules,
        GetRulesById
        
    }
